import React from "react";
import _ from 'lodash';
import {connect} from "react-redux";

import {Dialog, IconButton} from "@material-ui/core";
import DialogTitle from "@material-ui/core/DialogTitle";
import CloseIcon from "@material-ui/icons/Close";
import DashboardTable from "../../../../../../../../components/DashboardTable/DashboardTable";
import {default as IconBtn} from "../../../../../../../../components/Buttons/IconButton";
import PlusBackgroundIcon from "../../../../../../../../images/PlusBackgroundIcon";
import Create from "../../../../../../components/TradeStep/components/Create/Create";
import PaymentPlanEditTable from "../../../PaymentPlanEditTable/PaymentPlanEditTable";
import {getSavingsPlansTableStructure} from "../../../PaymentPlanEditTable/table-data";
import {getPaymentPlanMaxStartDate, TRANSACTION_TYPE_VALUES} from "../../../../../../constants";

function EditTable(props) {
  const {
    portfolio,
    allInstruments,
    portfolioComponents,
    action,
    dataService,
    addPaymentPlanOption,
    removePortfolioPaymentPlanOption,
    removePaymentPlanOption,
    isVirtual,
  } = props;

  return (
    <PaymentPlanEditTable
      addPaymentPlanOption={addPaymentPlanOption}
      removePortfolioPaymentPlanOption={removePortfolioPaymentPlanOption}
      removePaymentPlanOption={removePaymentPlanOption}
      transactionType={TRANSACTION_TYPE_VALUES.SAVINGS_PLAN}
      isVirtual={isVirtual}
      {...props}
    >
      {
        (EditTableProps) => (
          <>
            <DashboardTable
              tableLayout={"auto"}
              dataSource={EditTableProps.indexedGroupInstruments || []}
              structure={getSavingsPlansTableStructure(action, portfolio.isModelportfolio, isVirtual, EditTableProps.isAnlageberatung)}
              tableClasses={EditTableProps.classes}
              withFooter={false}
              expanded
              withInputs
              options={{
                isVirtual: isVirtual,
                discountsDisabled: !_.get(portfolio, 'ordering_discounts_allowed', []).includes('payment_plan'),
                availableDiscounts: portfolio.availableDiscounts,
                combinedDiscounts: portfolio.combinedDiscounts,
                depotDiscount: portfolio.discount,
                rotationOptions: portfolio.isModelportfolio
                  ? portfolio.availableMPSavingsPlanPeriodicPlans
                  : portfolio.availableSavingsPlanPeriodicPlans,
                fromDateOptions: portfolio.isModelportfolio
                  ? portfolio.availableMPSavingsPlanExecutionDates
                  : portfolio.availableSavingsPlanExecutionDates,
                handleDiscountChange: EditTableProps.handleDiscountChange,
                handleRotationChange: EditTableProps.handleRotationChange,
                handleDateChange: EditTableProps.handleDateChange,
                handleAmountChange: EditTableProps.handleAmountChange,
                onRemoveClick: EditTableProps.onRemoveClick,
                onRemoveAllClick: EditTableProps.onRemoveAllClick,
                isModelportfolio: portfolio.isModelportfolio,
                withSrri: EditTableProps.isAnlageberatung,
                clientSRRI: dataService.srri,
                tillDateEnabled: portfolio.ordering_savings_plan_till_date_enabled,
                deleteDateEnabled: portfolio.ordering_savings_plan_delete_date_enabled,
                maxStartDate: (item) => getPaymentPlanMaxStartDate(item, portfolio, action)
              }}
            />
            {/* FIXME: add tooltip for Einzeltitel <TableTooltip text={USE_CUSTODIAN_ONLINE_PORTAL_INFO_TEXT} />*/}
            <>
              {EditTableProps.isEnableAdding(action) && (
                <div className={EditTableProps.classes.addBtnContainer}>
                  <IconBtn
                    label={'Sparplan Positionen hinzufügen'}
                    component={PlusBackgroundIcon}
                    onClick={() => EditTableProps.handleAddSavingPlanButtonClick(action)}
                    size={36}
                  />
                </div>
              )}
              <Dialog maxWidth="lg" fullWidth disableBackdropClick={true} open={EditTableProps.open} onClose={() => EditTableProps.setOpen(false)}>
                <DialogTitle>
                  <div className={EditTableProps.classes.header}>
                    <IconButton aria-label="close" className={EditTableProps.classes.closeButton} onClick={() => EditTableProps.setOpen(false)}>
                      <CloseIcon/>
                    </IconButton>
                  </div>
                </DialogTitle>
                <Create
                  portfolioInstruments={(portfolioComponents || []).filter(i => !!i.isin)}
                  instruments={allInstruments}
                  instrumentsHandler={EditTableProps.instrumentsHandlers[action]}
                  extraFilters={{custodian: portfolio.companyId}}
                  handleAddItems={(assets) => EditTableProps.handleAddItems(action, assets)}
                  portfolioOnly={['delete', 'edit'].includes(action)}
                  action={action}
                  withSrri={EditTableProps.isAnlageberatung}
                  clientSRRI={dataService.srri}
                  customerId={props.customer_id}
                  isCustomerApp={props.isCustomerApp}
                  isVirtual={isVirtual}
                  loading={EditTableProps.loading}
                />
              </Dialog>
            </>
          </>
        )
      }
    </PaymentPlanEditTable>
  )
}

export default connect() (EditTable);